export default __webpack_public_path__ + "static/media/List-documentation.c9f793f7.md";